export enum NotificationColor {
  GREEN = 'green',
  RED = 'red',
}

export interface NotificationViewModel {
  color: NotificationColor;
  message: string;
}
